import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=099c2c8d&"
import script from "./comment.vue?vue&type=script&lang=ts&"
export * from "./comment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099c2c8d')) {
      api.createRecord('099c2c8d', component.options)
    } else {
      api.reload('099c2c8d', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=099c2c8d&", function () {
      api.rerender('099c2c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/comment.vue"
export default component.exports